import { render } from "./DashboardVietBaiAdmin.vue?vue&type=template&id=640838ea"
import script from "./DashboardVietBaiAdmin.vue?vue&type=script&lang=js"
export * from "./DashboardVietBaiAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__